import styled from 'styled-components';
import { BlockSize } from 'libs/rendering/gltf/config';
import {
  MobileFrameHeaderHeight,
  FrameHeaderHeight,
  OldFrameSidebarWidth,
} from 'styles/constants';

import { customMedia } from 'styles/utils';

import Icon from 'components/Icon';

const NAV_ARROWS_WIDTH = '4vw';

// z-index must be grater than canvas z-index, or flickering occurs in the line between them
// TODO: alex remove after refactoring
export const TabStyled = styled.aside`
  z-index: 1007;
  position: fixed;
  left: ${OldFrameSidebarWidth}px;
  top: ${FrameHeaderHeight}px;
  ${customMedia.lessThan('medium')`
    left: 0;
    top: ${MobileFrameHeaderHeight}px;
  `}
  right: 0;
  width: 100%;
  height: ${props => props.tabHeight}px;
  display: flex;
  flex-direction: row;
`;

export const Navigation = styled.nav`
  font-size: ${props => props.theme.font.size.small};
  position: relative;
  padding-right: ${props => props.shouldScroll && NAV_ARROWS_WIDTH};
`;

export const NavigationList = styled.ul`
  user-select: none;
  display: flex;
  padding: 0;
  height: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  ::-webkit-scrollbar {
    display: none;
  }
  background: ${props => props.theme.color.wfWhite};
  border: 1px solid ${props => props.theme.color.wfGrey700};
  border-radius: 20px;
  width: ${props => (props.visible ? '100%' : '32px')};
  transition: width 256ms ease-in-out;
`;

export const NavigationRight = styled.nav`
  z-index: 2;
  width: ${NAV_ARROWS_WIDTH};
  height: 100%;
  background-color: ${props => props.theme.color.wfGrey100};
  font-size: ${props => props.theme.font.size.small};
  position: absolute;
  right: 0;
  box-shadow: -2px 0px 3px ${props => props.theme.color.greyLight};
  ul {
    padding: ${props => props.theme.spacing.xsmall};
    display: flex;
  }
`;

export const TabSection = styled.nav`
  border-right: 1px solid ${props => props.theme.color.wfGrey200};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
  height: 37px;
  min-width: ${BlockSize.width};
  display: flex;
  align-items: center;
  font-size: ${props => props.theme.font.size.small};
  line-height: 34px;
  padding: ${props =>
    `0 ${props.theme.spacing.small} 0 ${props.theme.spacing.small}`};
  justify-content: center;
  &:hover {
    ${props =>
      !props.unactive &&
      `
      cursor: pointer;
      background-color: props.theme.color.wfGrey200;
      border-right: 1px solid ${
        // eslint-disable-next-line no-shadow
        props =>
          props.isNextToActiveTab ? '#ffffff' : props.theme.color.wfGrey200
      };
    `}
    ${props =>
      props.isNextToActiveTab &&
      `
      border-right: 1px solid #ffffff;
    `}
  }
`;

export const TabSectionRight = styled(TabSection)`
  margin-left: auto;
  border-right: 0;
  border-left: 1px solid ${props => props.theme.color.wfGrey200};
`;

export const IconStyled = styled(Icon)`
  position: relative;

  border-radius: 3px;
  color: ${props =>
    props.isBody
      ? props.theme.color.wfBlue
      : props.isDrawing
      ? props.theme.color.wfPurple
      : props.theme.color.wfGrey};

  margin-right: 0.25rem;
`;

export const InfoSectionBottom = styled.aside`
  display: flex;
  z-index: 10001;
  position: fixed;
  font-size: ${props => props.theme.font.size.small};
  color: ${props => props.theme.color.wfGrey700};
  bottom: ${({ theme }) => theme.space[2]};
  left: calc(${props => props.left}px + ${({ theme }) => theme.space[2]});

  ${customMedia.lessThan('medium')`
    display: none;
  `}
`;

export const InfoItem = styled.li`
  flex-shrink: 0;
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: ${props => props.theme.color.wfGrey700};
  border-right: 1px solid ${props => props.theme.color.wfGrey700};
  &:first-child {
    cursor: pointer;
  }
  &:last-child {
    border-right: none;
  }
`;

export const SupScript = styled.span`
  top: -4px;
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
`;
